import BaseNavigationHistoryStepChecker from './BaseNavigationHistoryStepChecker'

export default class GeneralNavigationHistoryStepChecker extends BaseNavigationHistoryStepChecker {
  checkNavigationHistoryStep(to, from) {
    return to.name !== from.name
  }
}
